<span class="label" #labelRef>
  <ng-content></ng-content>
</span>

<div class="body" [class.body--waiting]="(step$ | async) === UploadStep.Waiting" [ngSwitch]="step$ | async">
  <ng-template [ngSwitchCase]="UploadStep.Waiting">
    <app-ui-file-picker-placeholder
      class="placeholder"
      [id]="id + '__placeholder'"
      [accept]="accept"
      [maxSize]="maxSize"
      (choose)="onChange($event)"
      [caption]="caption"
    ></app-ui-file-picker-placeholder>
  </ng-template>

  <ng-template [ngSwitchCase]="UploadStep.Uploading">
    <app-ui-file-picker-progress
      class="progress"
      [id]="id + '__progress'"
      [label]="labelRef.innerText"
      [file]="model"
      [model]="progress"
      (cancel)="onChange(undefined)"
    ></app-ui-file-picker-progress>
  </ng-template>

  <ng-template [ngSwitchCase]="UploadStep.ShowFile">
    <app-ui-file-picker-preview
      *ngIf="model"
      class="preview"
      [id]="id + '__preview'"
      [label]="labelRef.innerText"
      [file]="model"
      (delete)="onChange(undefined)"
    ></app-ui-file-picker-preview>
  </ng-template>
</div>
